exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control-noresize[data-v-2ed93d72]{resize:none}", ""]);

// exports
